import {Injectable} from "@angular/core";
import {ObservableBackendService} from "./observableBackend.service";
import {Observable} from "rxjs/Rx";
import {MailReceiverType} from "../domain/mailReceiverType";

/**
 * .
 * Created by jlado on 15/9/16.
 */
@Injectable()
export class MailReceiverTypeService {

    constructor(private backendService: ObservableBackendService) {
    }

    /*Por ahora, los Tipos de Receptores son estáticos: no hay ABM*/

    public getMailReceiverTypes(): Observable<MailReceiverType[]> {
        return this.backendService.get("mailReceiverTypes", null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/mailReceiverType.service.ts
 **/